export default "__VITE_ASSET__8e0101f8__"